import React from 'react';
import { Link } from 'gatsby';
import { navigate } from 'gatsby-link';
import { AppContextType, withAppContext } from 'context/AppContext';
import { PrismicInternalLink } from 'components/Slices/types';
import { SegmentService } from 'analytics';
import { PrismicLinkProps } from 'components/PrismicLink';
import { linkResolver } from 'helpers';

export type InternalLinkProps = PrismicLinkProps & {
    link: PrismicInternalLink;
    context?: AppContextType;
};

export const InternalLinkComponent = (props: InternalLinkProps) => {
    /**
     * Redirects the user to the target href and adds any existing query parameters.
     * @param {React.MouseEvent<HTMLAnchorElement>} event : the click event
     */
    const followLink = (event: React.MouseEvent<HTMLAnchorElement>): void => {
        event.preventDefault();

        const url = event.currentTarget.getAttribute('href') || '';

        SegmentService.trackLinkFollowed({ 'L - Destination Link': url }, props.slice);
        navigate(url);
    };

    const { label, link, className, children } = props;
    const url = linkResolver(link);

    return (
        <Link to={url} className={className} activeClassName="is-active" onClick={followLink}>
            {label || children}
        </Link>
    );
};

export const InternalLink = withAppContext(InternalLinkComponent);
